import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";
import {filter, first} from "rxjs/operators";
import {ProductService} from "../../product.service";
import {DbStoreState} from "../../../../store";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {Config} from "../../../../config/config";
import {Product} from "../../product";
import * as fromStore from "../../../../store";

@Injectable()
export class WoopaymentsPluginResolver implements Resolve<null> {

  constructor(
    private _productService: ProductService,
    private _store: Store<DbStoreState>
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data && route.parent.data['website'] ? route.parent.data['website'].id : route.parent.parent.data['website'].id;

      this._store.select(fromStore.getWebsitePluginsAndExtensions(websiteId)).subscribe((plugins: Product[]) => {
        if (plugins) {
          let woopayments = plugins.find((product: Product) => product.slug === Config.woocommercePaymentsPluginSlug);
          if (woopayments) {
            resolve(woopayments);
          }
          else {
            this._productService.getWordpressPlugins(websiteId, Config.woocommercePaymentsPluginSlug)
              .pipe(filter((response: DbResponse): boolean => !!response),
              first())
              .subscribe((response: DbResponse): void => {
                if (response.success) {
                  resolve(response.data.find(plugin => plugin.slug === Config.woocommercePaymentsPluginSlug));
                }
                else {
                  resolve(null);
                }
              });
          }
        }
        else {
          resolve(null);
        }
      });
    });
  }

}
